exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#user_data[data-v-47a3af95]{margin-bottom:.4rem}#review[data-v-47a3af95]{font-size:.8rem}#author_panel[data-v-47a3af95]{margin-bottom:.6rem}#author_panel button[data-v-47a3af95]{border-radius:.2rem;margin-right:.2rem;margin-bottom:.4rem}#averages_table[data-v-47a3af95]{margin-bottom:.6rem}.review-date[data-v-47a3af95]{font-size:.7rem;font-weight:700}h4[data-v-47a3af95]{font-size:1.2rem}@media (max-width:720px){#averages_table[data-v-47a3af95]{font-size:.7rem;margin-bottom:.6rem}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-47a3af95","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Review.vue
// module id = 169
// module chunks = 0